export const topAccountsHints = {
  topAccounts: 'The top accounts are the accounts with the highest balance of AE coins.',
  rank: 'Rank of the account in the top accounts list.',
  balance: 'Amount of AE tokens held by the account.',
  account: 'Account address.',
  percentage: 'Percentage of the circulating supply of AE coins that the account holds.',
}
